module.exports = __webpack_public_path__ + "static/media/lun_icon.1ce331d5.svg";